// extracted by mini-css-extract-plugin
export default {"tableStyle":"AttendanceStatisticsTable_tableStyle__KMAvc"};